import React from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";

function EmailVerified() {
  return (
    <>
    <Helmet>
      <title>Email vérifié | LMFP Photography</title>
      <meta name="robots" content="noindex, nofollow" />
    </Helmet>

    <div className="min-h-screen bg-gray-900 text-white flex items-center justify-center px-4">
      <div className="max-w-2xl w-full bg-white/5 border border-white/10 backdrop-blur-md rounded-3xl shadow-2xl p-8 md:p-12 text-center">
        <div className="flex justify-center mb-6">
          <div className="h-20 w-20 rounded-full bg-green-500/20 border border-green-400/30 flex items-center justify-center">
            <svg
              className="w-10 h-10 text-green-400"
              fill="none"
              stroke="currentColor"
              strokeWidth="2.5"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M5 13l4 4L19 7"
              />
            </svg>
          </div>
        </div>

        <p className="uppercase tracking-[0.25em] text-sm text-gray-400 mb-3">
          LMFP Photography
        </p>

        <h1 className="text-3xl md:text-4xl font-bold mb-4">
          Votre email a bien été vérifié
        </h1>

        <p className="text-gray-300 text-base md:text-lg leading-relaxed mb-8">
          Merci, votre compte est maintenant confirmé. Vous pouvez continuer
          votre navigation ou vous connecter à votre espace en toute sécurité.
        </p>

        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Link
            to="/login"
            className="px-6 py-3 rounded-xl bg-white text-black font-semibold hover:bg-gray-200 transition"
          >
            Se connecter
          </Link>

          <Link
            to="/"
            className="px-6 py-3 rounded-xl border border-white/20 text-white hover:bg-white/10 transition"
          >
            Retour à l’accueil
          </Link>
        </div>
      </div>
    </div>
    </>
  );
}

export default EmailVerified;